<template>
    <CDropdown
        inNav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                        src="img/user_profile.png"
                        class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>{{$t('account')}}</strong>
        </CDropdownHeader>
        <CDropdownItem href="/profile" v-if="isAuth">
            <CIcon name="cil-user" /> {{$t('profile')}}
        </CDropdownItem>
        <CDropdownItem href="/login" v-if="isAuth">
            <CIcon name="cil-lock-locked" /> {{$t('logout')}}
        </CDropdownItem>
        <CDropdownItem href="/login" v-if="!isAuth">
            <CIcon name="cil-user" /> {{$t('login.label')}}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
export default {
    name: 'TheHeaderDropdownAccnt',
    computed: {
        isAuth() {
            return localStorage.getItem('login') === 'true';
        }
    }
}
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
</style>
